import React, {useEffect, useRef} from "react";
import lottie from "lottie-web";
import jsonLoading from "../../assets/json/loading.json";

export default function LoadingSpin({ style = {} }) {
    const containerRef = useRef(null);
    const animationRef = useRef(null);

    useEffect(() => {
        if (containerRef.current) {
            animationRef.current = lottie.loadAnimation({
                container: containerRef.current,
                autoplay: false,
                loop: true,
                animationData: jsonLoading,
            });

            const timeoutId = setTimeout(() => {
                if (animationRef.current) {
                    animationRef.current.play();
                }
            }, 700);

            return () => {
                clearTimeout(timeoutId);
                if (animationRef.current) {
                    animationRef.current.destroy();
                }
            };
        }
    }, []);

    return (
        <div
            ref={containerRef}
            style={{
                width: "200px",
                height: "200px",
                position: "relative",
                margin: "0 auto",
                ...style
            }} />
    )
}